// extracted by mini-css-extract-plugin
export var menuItem = "B_tJ d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "B_tK d_Z d_bz d_bP";
export var menuMainLink = "B_tL d_f0 d_dB";
export var menuLink = "B_tM d_f0 d_dB";
export var icon = "B_p9 d_bC d_bP";
export var divider = "B_tN d_bC d_bP";
export var sublinks = "B_tP";
export var link = "B_mC";
export var Link = "B_rd q_rd q_qr q_qM";